<template>
  <div class="hero-workbench">
    <div class="service-switch">
      <button
        v-for="item in services"
        :key="item.key"
        type="button"
        class="service-option"
        :class="{ active: activeService === item.key }"
        @click="switchService(item.key)">
        <img class="service-icon" :src="item.iconSrc" :alt="item.label" />
        <span class="service-label">{{ item.label }}</span>
      </button>
    </div>

    <div class="panel">
      <div class="input-tabs">
        <button
          type="button"
          :class="{ active: inputMode === 'text' }"
          @click="inputMode = 'text'">粘贴文本</button>
        <button
          type="button"
          :class="{ active: inputMode === 'file' }"
          @click="inputMode = 'file'">上传 docx</button>
      </div>

      <div v-if="inputMode === 'text'" class="textarea-wrap">
        <textarea
          v-model="content"
          class="content-input"
          placeholder="粘贴一段待处理文本，进入工作台后可正式提交处理"></textarea>
      </div>

      <div v-else class="upload-wrap" @click="goWorkbench">
        <div class="upload-box">
          <i class="bi bi-cloud-arrow-up upload-icon"></i>
          <p>进入工作台上传 docx</p>
          <span>支持全文处理与检测报告精改</span>
        </div>
      </div>

      <div v-if="showPlatforms" class="platform-row">
        <span class="platform-label">检测平台</span>
        <div class="platform-tags">
          <button
            v-for="p in platforms"
            :key="p"
            type="button"
            class="platform-tag"
            :class="{ active: activePlatform === p }"
            @click="activePlatform = p">{{ p }}</button>
        </div>
      </div>

      <div class="action-row">
        <button
          v-if="inputMode === 'text'"
          type="button"
          class="ghost-btn"
          @click="content = ''">
          <i class="bi bi-trash"></i> 清空
        </button>
        <button type="button" class="submit-btn" @click="goWorkbench">
          开始处理
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import aigcSvg from '@/assets/svg/aigc-svg.svg'
import jcSvg from '@/assets/svg/jc-svg.svg'

export default {
  name: 'HeroWorkbench',
  data() {
    return {
      activeService: 'AIGC',
      inputMode: 'text',
      content: '',
      activePlatform: '知网',
      services: [
        { key: 'AIGC', label: '降AIGC', iconSrc: aigcSvg },
        { key: 'DEDUP', label: '降重复率', iconSrc: jcSvg }
      ],
      platforms: ['知网', '维普', '万方', '大雅', '格子达']
    }
  },
  computed: {
    showPlatforms() {
      return this.activeService === 'DEDUP' || this.activeService === 'AIGC'
    }
  },
  methods: {
    switchService(key) {
      this.activeService = key
    },
    goWorkbench() {
      this.$router.push({
        path: '/workbench',
        query: {
          service: this.activeService,
          mode: this.inputMode
        }
      })
    }
  }
}
</script>

<style scoped>
.hero-workbench {
  width: 100%;
  max-width: 520px;
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(25, 118, 210, 0.12);
  box-shadow:
    0 4px 6px rgba(15, 23, 42, 0.04),
    0 20px 48px rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.service-switch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 12px 12px 0;
  background: linear-gradient(180deg, #f8f9ff 0%, #fff 100%);
}

.service-option {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 12px;
  border-radius: 14px 14px 0 0;
  color: var(--text-muted);
  font-size: 15px;
  font-weight: 500;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.service-option:hover:not(.active) {
  color: var(--text-secondary);
  background: rgba(255, 255, 255, 0.7);
}

.service-option.active {
  color: var(--text-primary);
  font-weight: 600;
  background: #fff;
  box-shadow: 0 -2px 12px rgba(25, 118, 210, 0.08);
}

.service-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
}

.service-label {
  white-space: nowrap;
}

.panel {
  padding: 16px 18px 18px;
}

.input-tabs {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  margin-bottom: 14px;
  border-radius: 12px;
  background: #f3f4f8;
}

.input-tabs button {
  padding: 8px 16px;
  border-radius: 8px;
  color: var(--text-muted);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.input-tabs button.active {
  color: var(--primary);
  font-weight: 600;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06);
}

.textarea-wrap,
.upload-wrap {
  border: 1px solid #e8eaf3;
  border-radius: 14px;
  overflow: hidden;
  background: #f5faff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.textarea-wrap:focus-within {
  border-color: rgba(25, 118, 210, 0.45);
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.08);
  background: #fff;
}

.content-input {
  width: 100%;
  height: 200px;
  padding: 16px;
  border: none;
  outline: none;
  resize: none;
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-primary);
  background: transparent;
}

.content-input::placeholder {
  color: #a8b0c4;
}

.upload-wrap {
  cursor: pointer;
}

.upload-wrap:hover {
  border-color: rgba(25, 118, 210, 0.35);
}

.upload-box {
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: var(--text-muted);
}

.upload-icon {
  font-size: 36px;
  color: var(--primary);
}

.upload-box p {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
}

.upload-box span {
  font-size: 12px;
}

.platform-row {
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.platform-label {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
  flex-shrink: 0;
}

.platform-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.platform-tag {
  padding: 5px 12px;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #94a3b8;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.platform-tag:hover {
  border-color: rgba(25, 118, 210, 0.35);
  color: var(--text-secondary);
}

.platform-tag.active {
  border-color: var(--primary);
  background: var(--primary-light);
  color: var(--primary);
  font-weight: 600;
}

.action-row {
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.ghost-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  transition: color 0.2s ease, background 0.2s ease;
}

.ghost-btn:hover {
  color: var(--text-secondary);
  background: #f3f4f8;
}

.submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 148px;
  height: 42px;
  padding: 0 22px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1976d2 0%, #1976d2 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.submit-btn:hover {
  filter: brightness(1.05);
  box-shadow: 0 10px 24px rgba(25, 118, 210, 0.34);
}

.submit-btn:active {
  transform: scale(0.98);
}
</style>
